// @mui/material components
import { makeStyles } from '@mui/styles';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';

import styles from 'assets/jss/material-dashboard-pro-react/views/errorPageStyles.js';

const useStyles = makeStyles(styles);

export default function ConfirmEmail() {
  const classes = useStyles();
  return (
    <div className={classes.contentCenter}>
      <GridContainer>
        <GridItem md={12}>
          <h3 className={classes.title}>Success!</h3>
          <h3 className={classes.subTitle}>
            Please check your email and follow the instructions to confirm your
            account registration.
          </h3>
          <h4 className={classes.description}>You may close this tab.</h4>
        </GridItem>
      </GridContainer>
    </div>
  );
}
